export default {
  OtherAssistanceFormField__APPROVED_DEVICES_SUBTEXT:
    "Please ensure the Portable Oxygen Concentrator is on the list of approved devices",
  OtherAssistanceFormField__HEADER: "Other",
  OtherAssistanceFormField__OXYGEN_DEVICES_SUBTEXT:
    "Liquid and compressed oxygen devices are not allowed",
  OtherAssistanceFormField__PEANUT_ALLERGY: "Have peanut-dust allergy",
  OtherAssistanceFormField__PORTABLE_OXYGEN_CONCENTRATOR:
    "Bringing my own approved Portable Oxygen Concentrator",
};
